export const TERMS_OF_USE_URL =
  "https://docs.google.com/document/d/1x1O9uNSVD5WU_hRBPIaaI0gULEp4yYnsJoR6L8XEBvM/edit?usp=sharing";

export const HOME_PAGE = "/";

export const LOGIN_PAGE = "/login";

export const JOIN_PAGE = "/join";

export const JOIN_SUCCESS_PAGE = "/join-success";

export const FORGOT_PASSWORD_PAGE = "/forgot-password";

export const SET_PASSWORD_PAGE = "/:objectID/set-password";

export const CREATE_MEAL_REQUEST_PAGE = "/request/scheduling";

export const ONBOARDING_REQUESTS_PAGE = "/admin/onboarding";

export const ADMIN_MEAL_REQUESTS_PAGE = "/admin/meal_requests";

export const ADMIN_USERS_PAGE = "/admin/users";

export const ASP_DASHBOARD_PAGE = "/asp/dashboard";

export const MEAL_DONOR_DASHBOARD_PAGE = "/meal_donor/dashboard";

export const MEAL_DONOR_CALENDAR_PAGE = "/meal_donor/calendar";

export const MEAL_DONOR_FORM_PAGE = "/meal_donor/donate/";

export const MEAL_DONOR_UPCOMING_PAGE = "/meal_donor/upcoming";

export const MEAL_DONOR_CONFIRMATION_PAGE = "/meal_donor/confirmation";

export const YOUR_MATCHES_PAGE = "/meal_donor/matches";

export const SETTINGS_PAGE = "/settings";
